import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useUserStore = defineStore('user', () => {
  // 登录后存储的用户信息
  const token = ref('')
  const vehicleSpeedLevel = ref('')
  // 可根据实际返回字段继续添加
  const userInfo = ref({})

  // 设置用户信息
  function setUserInfo(info) {
    token.value = info.token || ''
    vehicleSpeedLevel.value = info.vehicleSpeedLevel || ''
    userInfo.value = info
  }

  // 清除用户信息
  function clearUserInfo() {
    token.value = ''
    vehicleSpeedLevel.value = ''
    userInfo.value = {}
  }

  return {
    token,
    vehicleSpeedLevel,
    userInfo,
    setUserInfo,
    clearUserInfo
  }
}, {
  persist: true
}) 